import { Component, OnInit } from '@angular/core';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { BannerService } from '../../services/mensagem.service';

@Component({
    selector: 'app-mensagem',
    templateUrl: './mensagem.component.html',
    styleUrls: ['./mensagem.component.css'],
    standalone: false
})
export class MensagemComponent implements OnInit {
  banners = [];
  loading = false;

  constructor(
    private bannerService: BannerService,
  ) { }

  ngOnInit(): void {
  }

  excluir(idmensagem: any) {
    this.loading = true;
    this.bannerService.excluir(idmensagem).subscribe((data: any) => {
      this.banners = [];
      this.bannerService.all().subscribe((m: any) => {
        this.banners = m.data;
        this.loading = false;
      });
    });
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.loading = true;
    this.banners = [];
    this.bannerService.all().subscribe((m: any) => {
      this.banners = m.data;
      this.loading = false;
    });
  }

}
